import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const NotifyInfo = (message) => {
    const notify = () => toast.info(message, { autoClose: 5000 });
    notify();
}

export const NotifySuccess = (message) => {
    const notify = () => toast.success(message, { autoClose: 5000 });
    notify();
}

export const NotifyError = (message) => {
    const notify = () => toast.error(message, { autoClose: 5000 });
    notify();
}

export const NotifyWarning = (message) => {
    const notify = () => toast.warning(message, { autoClose: 8000 });
    notify();
}